import {GIPages} from '@stencil/hotels-types/src/hotels-types';
import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';

export const buildGoData = ({
  page,
  locus,
  cityId = '',
  cityName = '',
  destinationType = '',
  cityMetaEid = '',
  checkInDate,
  checkOutDate,
  roomString = '',
  appliedFilter = {},
  propertyId = '',
  propertyName = '',
  countryCode = 'IN',
  locationData = '',
  mmtId = '',
}) => {
  const parsedCheckIn = parseDateIntoHermesString(checkInDate?.date);
  const parsedCheckOut = parseDateIntoHermesString(checkOutDate?.date);
  let searchQuery;
  if (typeof window !== 'undefined') {
    searchQuery = new URLSearchParams(window.location.search);
  } else {
    searchQuery = new URLSearchParams();
  }
  const utm_source = searchQuery.get('utm_source') || '';
  const utm_medium = searchQuery.get('utm_medium') || '';
  const utm_campaign = searchQuery.get('utm_campaign') || '';
  const ggl_loc = appliedFilter?.location_search
    ? appliedFilter?.location_search.find(item => item?.id_type === 'ggl_id')
    : null;

  const commonGoData = {
    lob: 'hotels',
    utm_source,
    utm_campaign: utm_campaign,
    utm_medium,
    locusData: {
      ...locus,
      countryCode,
    },
  };
  const queryData = `${parsedCheckIn}-${parsedCheckOut}-${roomString}`;
  let godata = {};
  switch (page) {
    case GIPages.Srp: {
      godata = {
        qd: queryData,
        cid: cityId,
        n: cityName,
        t: destinationType,
        eid: cityMetaEid,
        editOpen: true,
        hotel_filters: JSON.stringify(appliedFilter),
        oid: cityId,
        cc: countryCode,
        checkin: parsedCheckIn,
        checkout: parsedCheckOut,
        mmtId: mmtId,
        roomString,
        locationData,
        ...commonGoData,
        ggl_loc: ggl_loc ? {...ggl_loc} : null,
      };
      break;
    }
    case GIPages.Details:
      godata = {
        vcid: cityId,
        vhid: propertyId,
        t: destinationType,
        hn: propertyName,
        n: cityName,
        checkin: parsedCheckIn,
        checkout: parsedCheckOut,
        roomString,
        cc: countryCode,
        locationData,
        ...commonGoData,
      };
      break;
  }
  return godata;
};
